import { MessageCircle } from "lucide-react";
import { waLink, track } from "@/lib/store";

export const WhatsAppFloat = () => (
  <a
    data-testid="floating-whatsapp-trigger"
    href={waLink("Ciao iPhix, vorrei alcune informazioni.")}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => track("whatsapp_click", { from: "float" })}
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2.5 rounded-full bg-[#25D366] px-4 py-3 font-semibold text-white shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform hover:scale-105 active:scale-95"
  >
    <MessageCircle className="h-5 w-5" />
    <span className="hidden sm:inline">Scrivici su WhatsApp</span>
  </a>
);
